import { Box, Flex, Heading } from '@chakra-ui/react';
import { lineBreakToBr } from '../../../util';
import { responsiveValue } from '../../../assets/style/defaultTheme';

const { flexBoxDirection, participationContentBoxWidth } = responsiveValue;

type Props = {
  title: string;
  data: any;
};

function ParticipationContentItemNormal({ title, data }: Props) {

  return (
    <Flex justify="space-between" pt="3" pb="3" direction={flexBoxDirection}>
      <Heading size="2xl" color="b.bk" pb={{ base: "2", md: "0", lg: "0" }} textTransform="capitalize" >{title}</Heading>
      <Box color="b.g" lineHeight="1.6" w={participationContentBoxWidth} dangerouslySetInnerHTML={ {__html: lineBreakToBr(data)} }>
      </Box>
    </Flex>
  );
}

ParticipationContentItemNormal.defaultProps = {
};

export default ParticipationContentItemNormal;
